import Image from "next/image";

const renderBlock = ({ head, p1, p2, p3 }) => {
  return (
    <div className="col">
      <h5 className="heading body--xl">{head}</h5>
      <p>{p1}</p>
      <p>{p2}</p>
      <p>{p3}</p>
    </div>
  );
};
const Opportunity = ({
  head,
  subhead,
  imgUrl,
  imgAlt,
  blurDataURL,
  block1,
  commitmentHead,
  commitmentP1,
  commitmentP2,
}) => {
  return (
    <section className="opportunity full">
      <div className="opportunity__banner banner">
        <div className="opportunity__copy">
          <div className="section-header">
            <h1
              className="heading heading--xl"
              dangerouslySetInnerHTML={{ __html: head }}
            ></h1>
          </div>
          <h4 className="heading heading--sm">{subhead}</h4>
          <div className="potential-col">{renderBlock(block1)}</div>
          <div className="image-box">
            <div className="col image-box__image-wrapper">
              <Image
                src={imgUrl}
                style={{ objectFit: "cover" }}
                alt={imgAlt}
                blurDataURL={blurDataURL}
                placeholder="blur"
                width={1500}
                height={1011}
                className="image"
                sizes="50vw"
              />
            </div>
            <div className="col image-box__text">
              <h6 className="heading heading--xxs">
                <Image
                  src="/leadership/heart.svg"
                  width="24"
                  height="24"
                  alt="heart"
                />
                <span className="pl-2">{commitmentHead}</span>
              </h6>
              <div className="body body--sm">
                <p>{commitmentP1}</p>
                <p>{commitmentP2}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Opportunity;
